export default {
    "male": "Nam",
    "female": "Nữ",
}
